import { call, fork, select,  takeLatest } from 'redux-saga/effects';

import { fetchPracticesByOrder, rejectPractice } from '../api';

import { practiceListActions } from './actions';
import { getPracticeListById, getCurrentPracticeList } from './selectors';

export function* loadPracticeList({payload}) {
  const { practiceListId } = payload;
  const practiceList = yield select(getPracticeListById, practiceListId);
  if (practiceList) {
    yield call( fetchPracticesByOrder, practiceListId, practiceList.filters );
  }
}

export function* setRejectPractice({payload}) {
    yield call(rejectPractice, payload);
    const practiceList = yield select(getCurrentPracticeList)
    yield call( fetchPracticesByOrder, practiceList.id, practiceList.filters );
}

//=====================================
//  WATCHERS
//-------------------------------------

export function* watchLoadPracticeList() {
  yield takeLatest(practiceListActions.LOAD_PRACTICES, loadPracticeList);
}

export function* watchRejectPractice() {
    yield takeLatest(practiceListActions.REJECT_PRACTICE, setRejectPractice);
}

//=====================================
//  ROOT
//-------------------------------------

export const practiceListSagas = [
  fork(watchLoadPracticeList),
  fork(watchRejectPractice),
];
